export const CIV_STATUS_BY_CODE = {
  AA: {
    description: 'Appeal Approved',
    actionType: 'no',
    actionText: "Don't Review",
  },
  CA: {
    description: 'Approved',
    actionType: 'no',
    actionText: "Don't Review",
  },
  CC: {
    description: 'Approved, Applicant Contacted',
    actionType: 'no',
    actionText: "Don't Review",
  },
  CL: {
    description: 'Closed - Duplicate',
    actionType: 'no',
    actionText: "Don't Review",
  },
  CU: {
    description: 'Approved, Applicant Unreachable/Not Contacted',
    actionType: 'no',
    actionText: "Don't Review",
  },
  MA: {
    description: 'COM Approval Withdrean, Applicant Contacted',
    actionType: 'no',
    actionText: "Don't Review",
  },
  MU: {
    description: 'COM Approval Withdrawn, Applicant Unreachable/Not Contacted',
    actionType: 'no',
    actionText: "Don't Review",
  },
  MW: {
    description: 'COM Approval Withdrawn ',
    actionType: 'no',
    actionText: "Don't Review",
  },
  WD: {
    description: 'Application Withdrawn',
    actionType: 'no',
    actionText: "Don't Review",
  },
  AB: {
    description: 'Abandoned',
    actionType: 'no',
    actionText: "Don't Review",
  },
  CN: {
    description: 'Not Approved',
    actionType: 'review',
    actionText: 'Review if Possible',
  },
  IG: {
    description: 'Ineligible',
    actionType: 'review',
    actionText: 'Review if Possible',
  },
  RN: {
    description: 'Returned to NVC',
    actionType: 'review',
    actionText: 'Review if Possible',
  },
  RC: {
    description: 'Referred to COM',
    actionType: 'no',
    actionText: "Don't Review",
  },
  AD: {
    description: 'Appeal Denied',
    actionType: 'review',
    actionText: 'Review if Possible',
  },
  DA: {
    description: 'Denied, Applicant Contacted',
    actionType: 'review',
    actionText: 'Review if Possible',
  },
  DC: {
    description: 'Documentation Complete',
    actionType: 'review',
    actionText: 'Review if Possible',
  },
  DU: {
    description: 'Denied, Applicant Unreachable / Not Contacted',
    actionType: 'review',
    actionText: 'Review if Possible',
  },
  I3: {
    description: 'Inactive 90 days',
    actionType: 'review',
    actionText: 'Review if Possible',
  },
  I6: {
    description: 'Inactive 180 days',
    actionType: 'review',
    actionText: 'Review if Possible',
  },
  NA: {
    description: 'Not Approved, Applicant Contacted',
    actionType: 'review',
    actionText: 'Review if Possible',
  },
  NN: {
    description: 'Not Approved, Appliant Not Contacted',
    actionType: 'review',
    actionText: 'Review if Possible',
  },
  UA: {
    description: 'Under Appeal',
    actionType: 'review',
    actionText: 'Review if Possible',
  },
  II: {
    description: 'Interagency Review Incomplete',
    actionType: 'review',
    actionText: 'Review if Possible',
  },
  IR: {
    description: 'Interagency Review Complete',
    actionType: 'review',
    actionText: 'Review if Possible',
  },
  AT: {
    description: 'Active',
    actionType: 'review',
    actionText: 'Review if Possible',
  },
} as const;
export type CivStatusCode = keyof typeof CIV_STATUS_BY_CODE;
